import React from 'react';
/**
 * Array 对象小工具
 * @Author gufuyan
 * @Date 2018-08-30
 */
class ArrayFn {
    //函数参数默认值
    constructor() {

    }

    in_array = ()=> {
        // Array.prototype.S = String.fromCharCode(2);
        // Array.prototype.in_array = function (e) {
        //     let r = new RegExp(this.S + e + this.S);
        //     return (r.test(this.S + this.join(this.S) + this.S));
        // };
        // Array.prototype.removeByValue = function (val) {
        //     for (let i = 0; i < this.length; i++) {
        //         if (this[i] == val) {
        //             this.splice(i, 1);
        //             break;
        //         }
        //     }
        // };
    }
}

let _Array = new ArrayFn();

export {_Array}


